import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Handler } from "@insite/client-framework/HandlerCreator";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { BrandModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

interface Parameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
    widgetPosition?: number;
    configurationProductsIds?: string[];
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    additionalSort?: (products: ProductModel[]) => ProductModel[];
}

type HandlerType = Handler<Parameter, Props>;

const LoadConfigurationProducts: HandlerType = props => {
    const {
        parameter: { carouselType, numberOfProductsToDisplay, brand, isProductDetailsPage, configurationProductsIds },
    } = props;

    if (carouselType !== "bundleProducts" || !isProductDetailsPage || !configurationProductsIds) {
        return;
    }

    const ProductIds:string[]=[];
    configurationProductsIds.forEach((ids: any) => {
        if(ids.length) {
            ids?.forEach((childId: string) => {
                ProductIds.push(childId)
            })
        }
        
    });
    
    if(carouselType === "bundleProducts") {
        props.getProductCollectionParameter = {
            pageSize: numberOfProductsToDisplay,
            ProductIds,
            includeAttributes: "includeOnProduct",
            expand: ["attributes"],
        } as any;
    } else {
        props.getProductCollectionParameter = {
            pageSize: numberOfProductsToDisplay,
            productIds: configurationProductsIds,
            includeAttributes: "includeOnProduct",
            expand: ["attributes"],
        } as any;
    }
};

addToChainBefore(chain, LoadProducts, LoadConfigurationProducts);

replaceInChain(chain, LoadProducts, props => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP =
        props.parameter.carouselType === "recentlyViewed" && props.parameter.isProductDetailsPage;

    props.getProductCollectionParameter.expand
        ? props.getProductCollectionParameter.expand.push("images", "badges", "properties")
        : (props.getProductCollectionParameter.expand = ["images", "badges", "properties"]);

    props.dispatch(
        loadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? props.parameter.productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit: props.parameter.isShellEdit,
            additionalSort: props.additionalSort
        }),
    );
});
